module.exports = __webpack_public_path__ + "img/nigeria-flag-mobile.0778bbcb.svg";